import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button as AIMEButton } from "tot-loft-component-library";
import { OutlineEye, OutlineEyeOff, PaartnerLogo } from "./assets";
import * as PRTNR from "./prtnr";
import { SetupNewPassword } from "./redux/slices/authThunks";

export default function NewPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [password, setPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [apiError, setApiError] = useState("");

  const uid = params.get("uid");
  const token = params.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    setApiError(""); // Clear old error

    if (!password || !confirmPassword) {
      return;
    }

    if (password !== confirmPassword) {
      alert("Password does not Match");
      return;
    }

    try {
      await dispatch(
        SetupNewPassword({
          userId: uid,
          token: token,
          newPassword: password,
        })
      ).unwrap();
      toast.success("Password set Successfully. Please Login");

      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
    } catch (err) {
      console.warn(err.message || "Failed to reset password");
      setApiError(err);
    }
  };

  return (
    <RootWrapperHome>
      <Header>
        <HeaderWrapper>
          <Left>
            <Logo
              onClick={() => navigate("/")}
              src={PaartnerLogo}
              alt="Paartner Logo"
            />
          </Left>
        </HeaderWrapper>
      </Header>
      <Section>
        <Wrapper>
          <SignupSignin>
            <ContentBlock1>
              <Content>
                <EarningCashForMakingReferralsIsEasierThanEver>
                  New Password
                </EarningCashForMakingReferralsIsEasierThanEver>
                <DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
                  Please create a new password.
                </DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
              </Content>
            </ContentBlock1>
            <Frame58>
              <PRTNR.Input
                label="Password"
                value={password}
                type={showPassword ? "text" : "password"}
                icon={showPassword ? OutlineEye : OutlineEyeOff}
                onIconClick={() => setShowPassword(!showPassword)}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                error={submitted && !password}
                errorMessage={"Required"}
                required
              />
              <PRTNR.Input
                label="Confirm password"
                value={confirmPassword}
                type={showConfirmPassword ? "text" : "password"}
                icon={showConfirmPassword ? OutlineEye : OutlineEyeOff}
                onIconClick={() => setShowConfirmPassword(!showConfirmPassword)}
                onChange={(e) => {
                  setconfirmPassword(e.target.value);
                }}
                error={submitted && !confirmPassword}
                errorMessage={"Required"}
                required
              />
              {apiError && <ErrorMessage>{apiError}</ErrorMessage>}
              <Frame59>
                <AIMEButton
                  size="small"
                  onClick={(e) => handleSubmit(e)}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    width: "320px",
                    background: "rgb(33, 37, 67)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                    "&:hover": {
                      background: "rgb(33, 37, 67)",
                      opacity: "0.9",
                    },
                    "@media (max-width: 768px)": {
                      width: "100%",
                    },
                    "@media (max-width: 480px)": {
                      width: "100%",
                    },
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Create new password
                  </span>
                </AIMEButton>
                <AIMEButton
                  size="small"
                  onClick={() => {
                    window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    width: "320px",
                    background: "#E2E8F0",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                    "&:hover": {
                      background: "#E2E8F0",
                      opacity: "0.9",
                    },
                    "@media (max-width: 768px)": {
                      width: "100%",
                    },
                    "@media (max-width: 480px)": {
                      width: "100%",
                    },
                  }}
                >
                  <span
                    style={{
                      color: "#212543",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Back to Login
                  </span>
                </AIMEButton>
              </Frame59>
            </Frame58>
          </SignupSignin>
        </Wrapper>
      </Section>
    </RootWrapperHome>
  );
}

const RootWrapperHome = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 24px 16px;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Logo = styled.img`
  width: 165px;
  height: 24px;
  position: relative;
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 8px;
  align-self: stretch;
  height: 882px;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  box-sizing: border-box;
`;

const SignupSignin = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ContentBlock1 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 560px;
  box-sizing: border-box;
  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const EarningCashForMakingReferralsIsEasierThanEver = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(24px, 2.5vw, 48px);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(16px, 2vw, 20px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 24px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 32px;
  width: 560px;
  background: rgb(226, 232, 240);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 32px;
  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  margin-top: 4px;
  text-align: left;
  width: 100%;
`;
const Frame59 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
